export default __webpack_public_path__ + "img/6f3a769c55fd34aed86e4b42bbd1cf41.png";